import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useUser } from '../../contexts/UserContext';
import '../../styles/components/pages/landing.css';

export default function Home() {
  const { login } = useAuth();
  const { user, roleData } = useUser();

  return (
    <div className="landing-container">
      <div className="landing-image">
        <img src="/images/buzz.png" alt="Georgia Tech Mascot Buzz" />
      </div>
      <div className="landing-content">
        <h1 className="landing-title">Welcome to The BrainBoost Instructional System!</h1>
        <p className="landing-subtitle">
          Practice course-based problem sets to build skills and confidence.
        </p>
        <div className="landing-buttons">
          {user ? (
            <>
              {(roleData === 'instructor') && (
                <Link to="/instructor">
                  <button className="btn btn-primary">Instructor Dashboard</button>
                </Link>
              )}
              {(roleData === 'student') && (
                <Link to="/dashboard">
                  <button className="btn btn-primary">Student Dashboard</button>
                </Link>
              )}
              {roleData && user?.chatbot_access === true && (
                <Link to="/lab-buddy">
                  <button className="btn btn-primary">Lab Buddy</button>
                </Link>
              )}
              {!roleData && (
                <Link to="/dashboard">
                  <button className="btn btn-primary">Go to Dashboard</button>
                </Link>
              )}
            </>
          ) : (
            <button onClick={() => login()} className="btn btn-primary">
              Login
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
